module.exports = __webpack_public_path__ + "img/rocketleague_bracket.c81ee93a.jpg";